export const getUploadNote = (brandName: string, isVideoAllowed?: boolean | undefined,) => {
    const noteMessage = `
        .jpeg, .jpg, .png 
        ${brandName === 'AVIDA' ? `, .webp` : ''}
        ${isVideoAllowed === true ? `, .mp4` : ``} 
        (max 50 MB)
    `
    return noteMessage;
}